<template>
  <div>
    <v-breadcrumbs class="systock-breadcrump">
      <v-breadcrumbs-item :title="breadcrumb">
        {{ breadcrumb }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>
    <v-tabs centered class="orcamento-configuracao">
      <v-tab @click="tab = 1">
        <v-icon left>mdi-account-tie</v-icon>
        Comprador
      </v-tab>
       <v-tab @click="tab = 2">
        <v-icon left>mdi-truck</v-icon>
        Fornecedor
      </v-tab>
      <v-tab-item>
        <comprador />
      </v-tab-item>
      <v-tab-item>
        <fornecedor />
      </v-tab-item>
    </v-tabs>
  </div>
</template>
<script>
import comprador from "./comprador";
import fornecedor from "./fornecedor";

export default {
  name: "orcamentoConfiguracao",
  components: {
    comprador, fornecedor
  },
  data() {
    return {
      tab: "",
      breadcrumb: "ORÇAMENTO / CONFIGURAÇÃO / COMPRADOR",
    };
  },
  watch: {
    tab() {
      if (this.tab == 1)
        this.breadcrumb = "ORÇAMENTO / CONFIGURAÇÃO / COMPRADOR";
      else if (this.tab == 2)
        this.breadcrumb = "ORÇAMENTO / CONFIGURAÇÃO / FORNECEDOR";
    },
  },
};
</script>
<style>
.orcamento-configuracao .v-icon.mdi-pencil:hover {
  color: blue;
}
.orcamento-configuracao .v-icon.mdi-delete:hover {
  color: red;
}
.orcamento-configuracao .input-descricao input {
  text-transform: uppercase;
}

.table-orcamento-resposivo .v-data-table__wrapper {
  height: calc(100vh - 260px) !important;
}

.systock-breadcrump {
  background-color: #7979790a;
  height: 2.5em;
}
.orcamento-configuracao .v-btn:not(.v-btn--round).v-size--default {
  height: 40px;
}
.orcamento-configuracao .v-data-footer__select .v-select {
  margin: 4px 0 6px 16px !important;
}
.orcamento-configuracao .v-data-table .v-toolbar__content {
  border-bottom: 1px solid #e0e0e0;
}
.orcamento-configuracao .v-data-table--fixed-header .v-data-footer {
  margin-right: 0;
  padding-right: 16px;
}

.orcamento-configuracao .v-tabs .v-tabs-bar {
  background-color: #7979790a !important;
}

.v-tabs-bar__content {
  border-bottom: 1px solid #f7f1f1;
  border-top: 1px solid #f7f1f1;
}

.v-card__actions {
  border-top: 1px solid #e0e0e0;
}
</style>
